import { render, staticRenderFns } from "./penundaan_tgl_jatuh_tempo.vue?vue&type=template&id=729a1338&"
import script from "./penundaan_tgl_jatuh_tempo.vue?vue&type=script&lang=js&"
export * from "./penundaan_tgl_jatuh_tempo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports